(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["approach-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-approach-guide-carousel]'
    const AUTOPLAY_MS = 4000

    const updateSlidePosition = (carousel, index) => {
      const track = carousel.querySelector('[data-approach-guide-track]')
      if (!track) return
      track.style.transform = `translateX(-${index * 100}%)`
    }

    const clearAutoplay = (carousel) => {
      if (carousel._approachGuideAutoplayId != null) {
        window.clearInterval(carousel._approachGuideAutoplayId)
        carousel._approachGuideAutoplayId = null
      }
    }

    const startAutoplay = (carousel) => {
      clearAutoplay(carousel)
      const slides = carousel.querySelectorAll('.approach-guide__slide')
      if (slides.length <= 1) return
      carousel._approachGuideAutoplayId = window.setInterval(() => {
        if (document.hidden) return
        let currentIndex = Number(carousel.dataset.currentIndex || '0')
        currentIndex = (currentIndex + 1) % slides.length
        carousel.dataset.currentIndex = String(currentIndex)
        updateSlidePosition(carousel, currentIndex)
      }, AUTOPLAY_MS)
    }

    const bindCarousel = (carousel) => {
      if (!carousel || carousel.dataset.carouselReady === 'true') return
      carousel.dataset.carouselReady = 'true'
      carousel.dataset.currentIndex = '0'
      updateSlidePosition(carousel, 0)
      startAutoplay(carousel)
    }

    const initCarousels = () => {
      document.querySelectorAll(selector).forEach(bindCarousel)
    }

    initCarousels()
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarousels, { once: true })
    }

    document.addEventListener('shopify:section:load', initCarousels)

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target
      if (!(root instanceof HTMLElement)) return
      root.querySelectorAll(selector).forEach((carousel) => {
        clearAutoplay(carousel)
        delete carousel.dataset.carouselReady
      })
    })

    document.addEventListener('visibilitychange', () => {
      document.querySelectorAll(selector).forEach((carousel) => {
        if (carousel.dataset.carouselReady !== 'true') return
        if (document.hidden) {
          clearAutoplay(carousel)
        } else {
          startAutoplay(carousel)
        }
      })
    })

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-approach-guide-prev], [data-approach-guide-next]')
      if (!button) return

      const carousel = button.closest(selector)
      if (!carousel) return

      if (carousel.dataset.carouselReady !== 'true') bindCarousel(carousel)

      const slides = carousel.querySelectorAll('.approach-guide__slide')
      if (slides.length === 0) return

      let currentIndex = Number(carousel.dataset.currentIndex || '0')

      if (button.hasAttribute('data-approach-guide-prev')) {
        currentIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1
      } else {
        currentIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1
      }

      carousel.dataset.currentIndex = String(currentIndex)
      updateSlidePosition(carousel, currentIndex)
      startAutoplay(carousel)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const headers = document.querySelectorAll('.site-header')
    headers.forEach((header) => {
      const toggle = header.querySelector('.header-menu-toggle')
      const mobileMenu = header.querySelector('.header-mobile-menu')
      if (!toggle || !mobileMenu) return

      const setOpen = (open) => {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
        header.classList.toggle('site-header--menu-open', open)
      }

      setOpen(false)

      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true'
        setOpen(open)
      })

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setOpen(false)
      })

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) setOpen(false)
      })

      const accountDropdown = header.querySelector('.header-account-dropdown')
      if (accountDropdown) {
        const trigger = accountDropdown.querySelector('[data-account-dropdown-trigger]')
        const setAccountExpanded = (open) => {
          if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false')
        }

        accountDropdown.addEventListener('mouseenter', () => setAccountExpanded(true))
        accountDropdown.addEventListener('mouseleave', () => setAccountExpanded(false))
        accountDropdown.addEventListener('focusin', () => setAccountExpanded(true))
        accountDropdown.addEventListener('focusout', (event) => {
          if (!accountDropdown.contains(event.relatedTarget)) setAccountExpanded(false)
        })
      }

      const currencyForm = header.querySelector('form.header-currency-form')
      const currencySelect = currencyForm ? currencyForm.querySelector('select') : null
      if (currencyForm && currencySelect) {
        const currencyTrigger = currencyForm.querySelector('.header-currency-trigger')
        if (currencyTrigger) {
          currencyTrigger.addEventListener('click', () => {
            if (typeof currencySelect.showPicker === 'function') {
              currencySelect.showPicker()
            } else {
              currencySelect.focus()
              currencySelect.click()
            }
          })
        }

        currencySelect.addEventListener('change', () => {
          currencyForm.submit()
        })
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-feature-carousel]');

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      const originalSlides = 4;
      let index = 0;
      let autoTimer;

      const setTransform = (withTransition = true) => {
        track.style.transition = withTransition ? 'transform 0.55s ease' : 'none';
        track.style.transform = `translateX(-${index * 25}%)`;
      };

      const next = () => {
        index += 1;
        setTransform(true);

        if (index === originalSlides) {
          window.setTimeout(() => {
            index = 0;
            setTransform(false);
          }, 560);
        }
      };

      const startAuto = () => {
        autoTimer = window.setInterval(next, 3000);
      };

      const stopAuto = () => {
        window.clearInterval(autoTimer);
      };

      carousel.addEventListener('mouseenter', stopAuto);
      carousel.addEventListener('mouseleave', startAuto);
      carousel.addEventListener('focusin', stopAuto);
      carousel.addEventListener('focusout', startAuto);

      setTransform(false);
      startAuto();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
